import { render, staticRenderFns } from "./IssueUpdateDialog.vue?vue&type=template&id=106ce6ab&"
import script from "./IssueUpdateDialog.vue?vue&type=script&lang=js&"
export * from "./IssueUpdateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports